<template lang="pug">
v-card
    v-menu(v-model="showMenu" :close-on-click="false" :close-on-content-click="false")
        template(v-slot:activator="{ on,attrs }")
            v-img(:src="car.Image ? (car.Image.startsWith('https://') ? car.Image : 'https://powersell.appstack.me/' + car.Image) : '/icons/add_photo.svg'" v-bind="attrs" v-on="on" class="portrait" height="300" width="600" lazy-src="https://picsum.photos/id/11/100/60")
        v-list
            v-list-item
                v-text-field(label="Image URL" v-model="car.Image" @change="updateImage")
    v-card-text
        v-row
        v-col(cols=12)
            v-text-field(label="Listing name" v-model="car.Name")
            v-select( dense v-model="car.ModelID" :items="models"  label="Model" item-text="Name" item-value="ID" solo attach)
            v-text-field(label="State of Health" v-model.number="car.Soh" type="number" suffix="%")
            v-text-field(label="Year" v-model.number="car.Year" type="number")
            v-text-field(label="Price" v-model.number="car.Price" type="number" prefix="$" hint="Price to use in recommendation calculations.")
            v-text-field(label="Listing Price" v-model="car.ListingPrice" prefix="$" hint="Price to show customers - can be monthly or weekly payments as well add that text if needed. Leave blank if the same as the price above.")
            v-text-field(v-model="car.ListingLink" label="Link to listing")
            v-checkbox(label="Archive this car (remove it from sale)" v-model="car.Archived")
</template>

<script>
export default {
    props:["car","models"],
    data() {
        return {
            showMenu: false
        }
    },
    computed: {
        imageSrc() {
            if (!this.car.Image || this.car.Image.length == 0) {
                return "/icons/add_photo.svg";
            }
            if (this.car.Image.indexOf("https://") === -1) {
                return "https://powersell.appstack.me" + (this.car.Image.startsWith("/") ? "" : "/" ) + this.car.Image
            } else {
                return this.car.Image
            }
        },   
         price() {
      return "$" + this.formatPrice(this.car.Price);
    }
    },
    methods: {
        updateImage() {
            
        }
    }
}
</script>